import React, { useEffect, FC, useState } from "react";
import { Modal, ModalBody, Form, Alert } from "reactstrap";
import { Icon, Button } from "../../../components/Component";
import { Col } from "reactstrap";
import { FormProvider, useForm } from "react-hook-form";
import FormSelect from "../../form-components/SelectComponent";
import Swal from "sweetalert2";
import rolesApi from "../../../api/master/roles";
import FormInput from "../../form-components/InputComponent";
import FormMultiSelect from "../../form-components/MultiSelectComponent";
interface SelectOptions {
  label: string;
  value: string;
}
const EditModal: FC<any> = ({
  modal,
  closeModal,
  onSubmit,
  formData,
  setFormData,
  filterStatus,
  alertInfo,
}) => {
  const methods = useForm({
    mode: "onChange",
  });
  const {
    reset,
    register,
    handleSubmit,
    control,
    formState: { errors },
    setValue,
  } = methods;
  const [roleOptions, setRoleOptions] = useState<SelectOptions[]>([]);
  const fetchRoles = async () => {
    try {
      const { data, status, message } = await rolesApi.fetchRolesData();
      if (status) {
        setRoleOptions(
          data.map((obj: any) => ({
            label: obj.roleName,
            value: obj.roleID.toString(),
          }))
        );
      } else {
        Swal.fire("Error", message, "error");
      }
    } catch (err: any) {
      Swal.fire("Error", err.response?.data?.message || err.message, "error");
    }
  };
  useEffect(() => {
    fetchRoles();
  }, []);
  useEffect(() => {
    reset((previousValues) => {
      const newData = Object.keys(previousValues).reduce((acc, key) => {
        return {
          ...acc,
          [key]: formData[key]?.toString(),
        };
      }, {});
      console.log(newData);
      return newData;
    });
    console.log("formData", formData);
    setValue(
      "roles",
      formData?.roles?.map((item: any) => item.roleID.toString())
    );
    setValue("referenceID", formData.referenceID);
  }, [formData]);
  return (
    <Modal
      isOpen={modal}
      toggle={() => closeModal()}
      className="modal-dialog-centered"
      size="xl"
      backdrop="static"
    >
      <ModalBody>
        <a
          href="#cancel"
          onClick={(ev) => {
            ev.preventDefault();
            closeModal();
          }}
          className="close"
        >
          <Icon name="cross-sm"></Icon>
        </a>
        <div className="p-2">
          <h5 className="title">Update General Ledger</h5>
          {alertInfo.message && (
            <div className="mb-3 mt-1">
              <Alert
                color={alertInfo.type === "error" ? "danger" : "success"}
                className="alert-icon"
              >
                <strong>{alertInfo.message}</strong>
                <Icon
                  name={
                    alertInfo.type === "error" ? "alert-circle" : "check-circle"
                  }
                />
                {alertInfo.errors.length > 0 ? (
                  <ul>
                    {alertInfo.errors.map((err: any, index: any) => (
                      <li key={index}>{err}</li>
                    ))}
                  </ul>
                ) : (
                  ""
                )}
              </Alert>
            </div>
          )}
          <div className="mt-4">
            <FormProvider {...methods}>
              <Form
                className="row gy-4"
                noValidate
                onSubmit={handleSubmit(onSubmit)}
              >
                <Col md="4">
                  <div className="form-group">
                    {/* <label className="form-label">
                    Internal ID<span className="mandatory">*</span>
                  </label> */}
                    <FormInput
                      required={true}
                      disabled
                      name="referenceID"
                      label="Ledger ID"
                      type="text"
                      pattern={/^[a-zA-Z0-9./_-]+$/}
                      defaultValue={formData.referenceID}
                      placeholder="Enter Ledger ID"
                    />
                  </div>
                </Col>
                <Col md="4">
                  <div className="form-group">
                    {/* <label className="form-label">Ledger Name<span className="mandatory">*</span></label> */}
                    <FormInput
                      name="ledgerName"
                      label="Ledger Name"
                      required={true}
                      type="text"
                      maxLength={100}
                      pattern={/^[a-zA-Z\s]*$/}
                      defaultValue={formData.ledgerName}
                      placeholder="Enter Ledger Name"
                    />
                  </div>
                </Col>
                <Col md="4">
                  <div className="form-group">
                    <FormMultiSelect
                      name="roles"
                      label="Select Role"
                      required={true}
                      options={roleOptions}
                    />
                  </div>
                </Col>
                <Col md="12">
                  <div className="form-group">
                    <FormInput
                      required={true}
                      name="description"
                      label="Description"
                      defaultValue={formData.description}
                      type="textarea"
                      placeholder="Write your description"
                    />
                  </div>
                </Col>
                <Col size="12">
                  <ul className="align-center flex-wrap flex-sm-nowrap gx-4 gy-2">
                    <li>
                      <Button color="primary" size="md" type="submit">
                        Update
                      </Button>
                    </li>
                    <li>
                      <a
                        href="#cancel"
                        onClick={(ev) => {
                          ev.preventDefault();
                          closeModal();
                        }}
                        className="link link-light"
                      >
                        Cancel
                      </a>
                    </li>
                  </ul>
                </Col>
              </Form>
            </FormProvider>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};
export default EditModal;
